import { Map } from 'immutable';

import Team from 'models/TeamModel';
import TeamMember from 'models/TeamMemberModel';

import { normalizeModelList } from '../../utils/Normalizer';

import { makeChampion, OPEN_MAKE_CHAMPION_MODAL, CLOSE_MAKE_CHAMPION_MODAL } from './types';

const makeChampionReducerObject = {
  [makeChampion.request]: (state) => state.setIn(['makeChampionModal', 'network', 'loading'], true),
  [makeChampion.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['makeChampionModal', 'network', 'loading'], false)
        .setIn(['makeChampionModal', 'network', 'error'], false)
        .mergeIn(['membersById'], normalizeModelList(action.response.users, TeamMember.deserialize))
        .mergeIn(
          ['teamsById'],
          normalizeModelList([action.response], (...args) => Team.deserialize(...args).normalize()),
        ),
    ),
  [makeChampion.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['makeChampionModal', 'network', 'loading'], false)
        .setIn(['makeChampionModal', 'network', 'error'], action.error),
    ),
  [OPEN_MAKE_CHAMPION_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['makeChampionModal', 'isOpen'], true)
        .setIn(['makeChampionModal', 'team'], action.team || null)
        .setIn(['makeChampionModal', 'teamMember'], action.teamMember || null)
        .setIn(['makeChampionModal', 'network'], Map({ loading: false, error: false })),
    ),
  [CLOSE_MAKE_CHAMPION_MODAL]: (state) =>
    state.withMutations((s) => s.setIn(['makeChampionModal', 'isOpen'], false)),
};

export default makeChampionReducerObject;
